import type { ProductProps } from '../index';
import { ProductPage } from '../shared';

export default function Product(props: ProductProps) {
  return <ProductPage {...props} kicker="Oferta" ctaLabel="Sim, eu quero" />;
}
